/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
import { bindActionCreators } from 'redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import SubmittedTimeCardComponent from './submittedTimeCard.Component';
import { ApiUrls } from '../../../services/api';
import * as moment from 'moment';
import Api from '../../../services/api/serviceCall';
import { Constants } from '../../../config/appConstants';
import { MessageBox } from '../../sharedComponent/messageBox';
import * as dateActions from '../../../actions/date.Action';
import { isEqual } from 'lodash';
import * as actions from '../../../actions/tmVoucher.Action';
import { EmptyAttestDetails, getAttestation } from '../Attestation/AttestationUtils';
import { replaceNullWithEmptyString } from '../../../services/utility';
/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class SubmittedTimeCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isIssueNotesModalVisible: false,
            isOpenTimeCardReview: false,
            selectedDate: this.props.date.selectedDate,
            issueNotesList: [],
            selectedAttachment: "",
            isAttachmentModelVisible: false,
            timeCardList: [],
            weekStartDate: null,
            weekEndingDate: null,
            selectedTimeCard: "",
            isShowPunchesModal: false,
            isShowPayrollNoteModal: false,
            isShowActualNoteModal: false,
            isShowExpectationNoteModal: false,
            isShowLoader: false,
            selectDate: '',
            dateSelected: '',
            isDatePickerOpen: false,
            isShowTMVoucher: this.props.tmVoucherReducer.setTmVoucherModelVisibility ?? false,
            tmTaskCodeList: [],
            selectedTMVoucher: {},
            tmVoucherConfirmMessage: '',
            selectedTimeCardPunches: {},
            isAllowAttestation: false,
        }
    }

    componentWillMount() {
        window.addEventListener('beforeunload', () => {
            this.props.setTmVoucherModelVisibility(false);
        });
        var current = new Date();
        var monday = (new Date(current.setDate(current.getDate() - current.getDay() + (current.getDay() == 0 ? -6 : 1))));
        var sunday = (new Date(current.setDate(current.getDate() - current.getDay() + 7)));
        this.setState({
            weekEndingDate: sunday, weekStartDate: monday
        }, () => {
            this.getTimeCardList();
            this.getTMVoucherTaskCodes();
        });
    }

    getTimeCardList() {
        var datePicked = new Date(this.state.selectedDate);
        var startTime = new Date(datePicked.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var tomorrow = new Date(this.state.selectedDate);
        var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        var selectedDate = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);
        var fromDate = `${selectDate} ${selectTimeZone}`;
        var toDate = `${selectedDate} ${selectTimeZone}`;
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_TME_CRD_DTE_RNG}?fromDate=${fromDate}&toDate=${toDate}&deviceId=${this.props.device.deviceId}&isSubmittedOnly=${true}`;
        Api.Get(url, this).then(responseData => {
            if (responseData.success) {
                this.setState({ isAllowAttestation: responseData.data.isAllowAttestation });
                var timeRecordData = responseData.data.timecardList;
                timeRecordData.sort((a, b) => (a.createdDate < b.createdDate) ? -1 : 1);
                timeRecordData.sort((a, b) => (a.timeRecordID - b.timeRecordID));
                var groupByName = timeRecordData.reduce((prev, curr) => {
                    if (curr.employeeID) {
                        var previousData = prev.find(a => a.employeeID === curr.employeeID);
                        if (prev && previousData) {
                            previousData.timecardData = [...previousData.timecardData || [], curr];
                            previousData.totalStHours = Number(previousData.totalStHours) + Number(curr.stHours ? curr.stHours : 0);
                            previousData.totalOtHours = Number(previousData.totalOtHours) + Number(curr.otHours ? curr.otHours : 0);
                            previousData.totalDtHours = Number(previousData.totalDtHours) + Number(curr.dtHours ? curr.dtHours : 0);
                            previousData.timeRecordIds = [...previousData.timeRecordIds || [], curr.timeRecordID];
                        }
                        else {
                            prev.push({
                                employeeName: curr.fullName,
                                employeeID: curr.employeeID,
                                employeeNumber: curr.employeeNumber,
                                timeRecordIds: [curr.timeRecordID],
                                timecardData: [curr],
                                totalStHours: Number(curr.stHours ? curr.stHours : 0),
                                totalOtHours: Number(curr.otHours ? curr.otHours : 0),
                                totalDtHours: Number(curr.dtHours ? curr.dtHours : 0)
                            });
                        }
                        return prev;
                    }
                    else {
                        prev = [];
                        return prev;
                    }
                }, []);

                this.setState({
                    timeCardList: groupByName,
                    selectDate: fromDate,
                    dateSelected: toDate
                });
            }
        });
    }

    onClickTimeCardReview() {
        this.setState({
            isOpenTimeCardReview: true
        });
    }

    handleDateChange(date) {
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date))) {
            this.setState({
                selectedDate: date,
            }, () => {
                this.props.onSelectDate(this.state.selectedDate);
                this.getTimeCardList();
                this.getTMVoucherTaskCodes();
            });
        }
        else {
            this.setState({
                timeCardList: []
            });
        }
    }

    getTimeCardIssue() {
        let { selectedDate } = this.state;
        var datePicked = new Date(selectedDate);
        var startTime = new Date(datePicked.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var tomorrow = new Date(datePicked);
        var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        var dateSelected = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ISE_NT_M}?fromDate=${selectDate}@${selectTimeZone}&toDate=${dateSelected}@${selectTimeZone}&deviceId=${this.props.device.deviceId}&isSubmittedOnly=${true}`;
        Api.Get(url, this,true,true).then(responseData => {
            if (responseData.success) {
                this.setState({
                    isIssueNotesModalVisible: true,
                    issueNotesList: responseData.data,
                    isShowLoader: false
                });
            } else {
                this.setState({ isShowLoader: false });
                MessageBox(responseData.message, Constants.ERROR);
            }
        });
    }

    closeIssueNotes(issue) {
        this.setState({
            isIssueNotesModalVisible: false
        })
    }

    onCloseTimeCardReview() {
        this.setState({
            isOpenTimeCardReview: false
        })
    }

    openAttachmentViewer(attachment) {
        this.setState({
            isAttachmentModelVisible: true,
            selectedAttachment: attachment
        });
    }

    closeAttachmentViewer() {
        this.setState({
            isAttachmentModelVisible: false,
            selectedAttachment: ""
        });
    }

    openOrClosePunchesModal = notes => {
        let { selectedTimeCardPunches } = this.state;
        if (notes.isShowPunchesModal) {
            selectedTimeCardPunches = {
                startTime: replaceNullWithEmptyString(notes.selectedTimeCardPunches.startTime),
                lunchStartTime: replaceNullWithEmptyString(notes.selectedTimeCardPunches.lunchStartTime),
                lunchEndTime: replaceNullWithEmptyString(notes.selectedTimeCardPunches.lunchEndTime),
                endTime: replaceNullWithEmptyString(notes.selectedTimeCardPunches.endTime),
            }
            this.setState({ isShowPunchesModal: notes.isShowPunchesModal, selectedTimeCardPunches });
        } else {
            this.setState({ isShowPunchesModal: false, selectedTimeCardPunches: {} });
        }
    }

    openOrClosePayrollNoteModel(visible, timeCard) {
        this.setState({
            isShowPayrollNoteModal: visible,
            selectedTimeCard: visible ? timeCard : ""
        });
    }

    openOrCloseActualNoteModel(visible, timeCard) {
        if (visible) {
            let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ATCHMT_BY_TMC_ID_M}?timeRecordId=${timeCard.timeRecordID}&deviceId=${timeCard.deviceID}`;
             Api.Get(url, this,true,true).then(response => {
                if (response.success) {
                    timeCard.attachments = response.data;
                    this.setState({
                        isShowActualNoteModal: visible,
                        selectedTimeCard: visible ? timeCard : "",
                        isShowLoader: false
                    });
                }
                else {
                    this.setState({ isShowLoader: false });
                    MessageBox(response.message, Constants.ERROR);
                }
            });
        } else {
            this.setState({
                isShowActualNoteModal: visible,
                selectedTimeCard: visible ? timeCard : ""
            });
        }

    }

    openOrCloseExpectationNoteModel(visible, timeCard) {
        this.setState({
            isShowExpectationNoteModal: visible,
            selectedTimeCard: visible ? timeCard : ""
        });
    }

    onClickBack() {
        this.props.onSelectDate(new Date());
        this.props.history.push("/TimeCard");
    }

    onClickCurrentWeekTimeCard() {
        this.props.history.push("/CurrentWeekTimeCard");
    }

    onClickPreviousWeekTimeCard() {
        this.props.history.push("/PreviousWeekTimeCard");
    }

    onClickDailyDetails = () => {
        let { selectDate, dateSelected } = this.state;
        this.props.history.push('DailyDetails', { fromDate: selectDate, toDate: dateSelected, isAllowToEdit: false, isNewStatus: true });
    }

    handleDatePickerOpenAndClose(isDateOpen = false) {
        if (typeof isDateOpen === 'boolean' && isDateOpen) {
            this.setState({ isDatePickerOpen: false });
        } else {
            this.setState({ isDatePickerOpen: true });
        }
    }

    onClickTMVoucherBtn() {
        this.props.setTmVoucherModelVisibility(true);
        this.setState({ isShowTMVoucher: true });
    }

    onClickTMVoucherBackBtn() {
        this.props.setTmVoucherModelVisibility(false);
        const { selectedTMVoucher } = this.state;
        isEqual(selectedTMVoucher, {}) ? this.setState({ isShowTMVoucher: false, selectedTMVoucher: {} }) : this.setState({ isShowTMVoucher: false, selectedTMVoucher: {} });
    }

    onChangeSelectTaskCode(taskCode) {
        this.setState({ selectedTMVoucher: taskCode });
    }

    getTMVoucherTaskCodes() {
        const { selectedDate } = this.state;
        let datePicked = new Date(selectedDate);
        let startTime = new Date(datePicked.setHours(0, 0, 0));
        let startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        let tomorrow = new Date(datePicked);
        let endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        let endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        let dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        let selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        let dateSelected = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        let timeZone = startDate.toString();
        let selectTimeZone = timeZone.slice(16, 24);
        let url = `${ApiUrls.Routes.TM_VCHR_C}${ApiUrls.Routes.GT_TM_VCHR_PRJ_TK_LT_M}?fromDate=${selectDate}@${selectTimeZone}&&toDate=${dateSelected}@${selectTimeZone}&deviceId=${this.props.device.deviceId}&isNotInProgress=true`;
        Api.Get(url, this).then((response) => {
            if (response.success) {
                if (response.data) {
                    this.setState({ tmTaskCodeList: response.data });
                }
            } else {
                MessageBox(response.message, Constants.ERROR);
            }
        });
    }

    onClickSelectBtn() {
       const { selectedTMVoucher } = this.state;
       if (isEqual(selectedTMVoucher, {})) {
           MessageBox(Constants.PLEASE_SELECT_TASK_CODE, Constants.ERROR);
       } else {
           this.props.setTmVoucherModelVisibility(true);
           this.props.history.push("/TMVoucherPDFViewer", {selectedTMVoucher});
       }
   }

    async openAttestation(timeRecordId, timeCardStatus) {
        const { timeCardList } = this.state;
        const records = timeCardList.map(t => t.timecardData).flat();
        const selectedRecord = records.find(t => t.timeRecordID === timeRecordId);
        const attestationPDF = selectedRecord?.attachmentContent ?? null;
        const url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ATTST_BTMCRD_ID_M}?deviceId=${this.props.device.deviceId}&timeRecordId=${timeRecordId}`;
        const attestationDetails = await getAttestation(url, timeCardList, timeRecordId, this);
        const isSubmittedAttestation = timeCardStatus !== Constants.IN_PROGRESS || attestationPDF !== null;
        this.props.history.push("Attestation", { timeRecords: timeCardList, attestationDetails, attestationPDF, isSubmittedAttestation, isFromWeekTimeCard: true });
    }

    render() {
        const { timeCardList, isOpenTimeCardReview, selectedDate, issueNotesList, isIssueNotesModalVisible, isAttachmentModelVisible, selectedAttachment,
            weekEndingDate, weekStartDate, isShowPunchesModal, selectedTimeCard, isShowPayrollNoteModal, isShowActualNoteModal, isShowExpectationNoteModal,
            isShowLoader, isDatePickerOpen, isShowTMVoucher, tmTaskCodeList, selectedTMVoucher, tmVoucherConfirmMessage,
            selectedTimeCardPunches, isAllowAttestation } = this.state;
        return (
            <Fragment>
                <SubmittedTimeCardComponent
                    {...{
                        timeCard: {
                            isOpenTimeCardReview,
                            isIssueNotesModalVisible,
                            selectedDate,
                            issueNotesList,
                            isAttachmentModelVisible,
                            selectedAttachment,
                            weekEndingDate,
                            weekStartDate,
                            timeCardList,
                            isShowPunchesModal,
                            isShowPayrollNoteModal,
                            selectedTimeCard,
                            isShowActualNoteModal,
                            isShowExpectationNoteModal,
                            isShowLoader,
                            isDatePickerOpen,
                            isShowTMVoucher,
                            tmTaskCodeList,
                            selectedTMVoucher,
                            tmVoucherConfirmMessage,
                            selectedTimeCardPunches,
                            isAllowAttestation,
                        }
                    }}
                    getTimeCardIssue={this.getTimeCardIssue.bind(this)}
                    onClickTimeCardReview={this.onClickTimeCardReview.bind(this)}
                    closeIssueNotes={this.closeIssueNotes.bind(this)}
                    closeAttachmentViewer={this.closeAttachmentViewer.bind(this)}
                    onCloseTimeCardReview={this.onCloseTimeCardReview.bind(this)}
                    openAttachmentViewer={this.openAttachmentViewer.bind(this)}
                    handleDateChange={this.handleDateChange.bind(this)}
                    openOrClosePunchesModal={this.openOrClosePunchesModal.bind(this)}
                    openOrClosePayrollNoteModel={this.openOrClosePayrollNoteModel.bind(this)}
                    openOrCloseActualNoteModel={this.openOrCloseActualNoteModel.bind(this)}
                    openOrCloseExpectationNoteModel={this.openOrCloseExpectationNoteModel.bind(this)}
                    onClickBack={this.onClickBack.bind(this)}
                    onClickCurrentWeekTimeCard={this.onClickCurrentWeekTimeCard.bind(this)}
                    onClickPreviousWeekTimeCard={this.onClickPreviousWeekTimeCard.bind(this)}
                    onClickDailyDetails={this.onClickDailyDetails.bind(this)}
                    handleDatePickerOpenAndClose={this.handleDatePickerOpenAndClose.bind(this)}
                    onClickTMVoucherBtn={this.onClickTMVoucherBtn.bind(this)}
                    onClickTMVoucherBackBtn={this.onClickTMVoucherBackBtn.bind(this)}
                    onChangeSelectTaskCode={this.onChangeSelectTaskCode.bind(this)}
                    onClickSelectBtn={this.onClickSelectBtn.bind(this)}
                    openAttestation={this.openAttestation.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device,
        date: state.dateReducer.date,
        tmVoucherReducer: state.tmVoucherReducer.selectedTMVouchers
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            dateActions, actions),
        dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubmittedTimeCard));

SubmittedTimeCard.displayName = 'SubmittedTimeCard';